export default defineAppConfig({
  icon: {
    size: '24px', // default <Icon> size applied
    class: 'icon', // default <Icon> class applied
    mode: 'css',
    aliases: {
      arrow: 'material-symbols:play-arrow-rounded',
      info: 'ant-design:info-circle-outlined',
      avatar: 'radix-icons:avatar',
      camera: 'ic:outline-photo-camera',
      library: 'fluent:library-28-regular',
      course: 'solar:document-text-linear',
      summary: 'tabler:list',
      wip: 'fluent:warning-48-regular',
      locked: 'ph:lock-simple',
      navigationBreadCrumb: 'iconamoon:arrow-right-2-duotone',
      video: 'fluent:video-clip-32-regular',
      nomadPlusContent: 'cil:smile-plus',
      file: 'ic:outline-insert-drive-file',
      unrollContent: 'material-symbols:keyboard-arrow-down-rounded',
      hideContent: 'material-symbols:keyboard-arrow-up-rounded',
      trophy:
        'streamline:interface-award-trophy-reward-rating-trophy-social-award-media',
      challenge: 'tabler:brand-speedtest',
      inTheNews: 'fluent:flash-24-regular',
      popinAddingContent: 'material-symbols:support-agent',
      popinUpdatingContent: 'iconoir:walking',
      popinOpenContent: 'iconoir:open-in-window',
      warning: 'ph:warning-circle-light',
      dialogError: 'material-symbols:heart-broken',
      dialogSuccess: 'fluent:like-16-regular',
      trophyDone: 'ic:round-done',
      watchCourse: 'ph:text-align-left',
      quizReplay: 'mdi:sync',
      quizNext: 'fe:forward',
      quiz: 'material-symbols:quiz',
      doQuiz: 'material-symbols-light:quiz-outline-sharp',
      quizChoiceReplay: 'ic:round-arrow-right',
      quizShare: 'ri:share-forward-line',
      next: 'ic:round-arrow-forward-ios',
      previous: 'ic:round-arrow-back-ios',

      nextSmall: 'material-symbols:chevron-right-rounded',
      previousSmall: 'material-symbols:chevron-left-rounded',
      cross: 'basil:cross-solid',
      reviewQuestion: 'iconamoon:synchronize-fill',
      goodAnswer: 'material-symbols:check-small-rounded',
      wrongAnswer: 'material-symbols:exclamation',
      quizQuestionSubmit: 'material-symbols:done',
      quizPause: 'mi:pause',
      librarySettings: 'material-symbols:settings-outline-rounded',
      trash: 'mdi:trash-can-outline',
      settings: 'ph:gear',
      logout: 'ci:log-out',
      eye: 'material-symbols:visibility-outline',
      subjects: 'material-symbols:tips-and-updates-outline-rounded',
      exam: 'icon-park-outline:hourglass-null',
      headQuestion: 'mdi:head-question-outline',
      fullScreenOn: 'ic:round-fullscreen',
      fullScreenOff: 'material-symbols:fullscreen-exit-rounded',
      closeScreen: 'ant-design:close-outlined',
      modalScreen: 'clarity:window-restore-line',
      family: 'material-symbols:family-restroom-rounded',
      share: 'mingcute:share-forward-line',
      code: 'codicon:key',
      tutorial: 'ion:md-help',
      gauge: 'lucide:gauge',
      today: 'material-symbols:calendar-today-outline',
      exit: 'ic:round-exit-to-app',
      account: 'solar:user-rounded-bold',
      accessibility: 'fluent:accessibility-48-regular',
      faq: 'iconoir:chat-bubble-question',
      sponsor: 'fluent:handshake-20-regular',
      accountFamily: 'carbon:pedestrian-family',
      checkbox: 'mdi:check-bold',
      eyeOpen: 'ph:eye-light',
      eyeClose: 'ph:eye-slash',
      loading: 'svg-spinners:90-ring-with-bg',
      refresh: 'material-symbols:refresh-rounded',
      clickMe: 'f7:hand-point-right',
      closeSmall: 'material-symbols-light:close-small-rounded',
      edit: 'material-symbols:stylus-outline',
      gaming: 'ion:game-controller-outline',
      plus: 'mi:add',
      statistics: 'cil:chart',
      chapter: 'material-symbols:menu-book-outline-rounded',
      magnifier: 'iconamoon:search',
      clock: 'ic:round-access-time',
      home: 'lucide:house',
      assessment: 'hugeicons:diploma',
      debug: 'gg:debug',
      bulb: 'teenyicons:bulb-on-outline',
      correction:
        'streamline:interface-file-clipboard-check-checkmark-edit-task-edition-checklist-check-success-clipboard-form',
      statement: 'healthicons:magnifying-glass-outline',
      play: 'solar:play-bold',
      pause: 'solar:pause-bold',
      audioOn: 'streamline:volume-level-high',
      audioOff: 'streamline:volume-mute',
      record: 'material-symbols-light:fiber-manual-record',
      calculator: 'teenyicons:calculator-outline',
      shareMail: 'ion:ios-share-alt',
      deeplink: 'icon-park:deeplink',
    },
  },
});
